import type { CalendarDateAnnotation } from './calendar.types';

const variables: { dateAnnotation?: CalendarDateAnnotation } = {
  dateAnnotation: undefined,
};

export default variables;
